<div [formGroup]="formGroup">
  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 field-wrapper text-sm-left focused"
         data-cy="mb-checkout-address-country">
      <label for="country"
             [ngClass]="[isCountryDisabled ? 'mb-disable-label' : '', 'mandatory-input-asterisk mb-input-field-cursor mb-custom-label']">{{ countryLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             data-cy="mb-checkout-address-country-input"
             id="country"
             name="country"
             type="text"
             formControlName="country"
             required/>
      <mb-form-errors [control]="formGroup?.get(constants.COUNTRY_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>
  </div>
</div>
